import React from 'react'
import styled from 'styled-components'

import { TResponsiveProps, responsiveStyle } from '@hozana/styling/responsive'

import { Div, TDivProps } from './Div'

const responsiveProps = { borderRadius: 'border-radius' } as const

type TWrapperProps = TDivProps & TResponsiveProps<typeof responsiveProps>

export const Wrapper = styled(Div)<TWrapperProps>`
  box-shadow: 0px 2px 2px rgb(0 0 0/ 20%), 0px 0px 1px 1px rgb(0 0 0 / 5%);
  ${responsiveStyle(responsiveProps)}
  @media print {
    border: none;
    box-shadow: none;
  }
`

export type TBlockProps = {
  square?: boolean // if not set, the corners will be rounded
  borderRadius?: string // if not set, the corners will be rounded
} & TWrapperProps

export const Block: TFCC<TBlockProps> = ({ square, children, borderRadius, ...otherProps }) => (
  <Wrapper bg="white" borderRadius={borderRadius || (square ? { xs: '0', sm: '16px' } : '16px')} {...otherProps}>
    {children}
  </Wrapper>
)
